"use strict";

exports.__esModule = true;
exports.URL_KEY_PRESSED = exports.SUCCESSFUL_REQUEST = exports.SHORTCUT_SUBMITTED = exports.NEW_HEADER_CREATED = exports.INIT_APITESTER = exports.ID_TOKEN_COPIED = exports.HTTP_METHOD_CHANGED = exports.HEADER_KEY_PRESSED = exports.BODY_CHANGED = void 0;
const INIT_APITESTER = exports.INIT_APITESTER = 'INIT_APITESTER';
const NEW_HEADER_CREATED = exports.NEW_HEADER_CREATED = 'NEW_HEADER_CREATED';
const ID_TOKEN_COPIED = exports.ID_TOKEN_COPIED = 'ID_TOKEN_COPIED';
const URL_KEY_PRESSED = exports.URL_KEY_PRESSED = 'URL_KEY_PRESSED';
const HEADER_KEY_PRESSED = exports.HEADER_KEY_PRESSED = 'HEADER_KEY_PRESSED';
const HTTP_METHOD_CHANGED = exports.HTTP_METHOD_CHANGED = 'HTTP_METHOD_CHANGED';
const BODY_CHANGED = exports.BODY_CHANGED = 'BODY_CHANGED';
const SHORTCUT_SUBMITTED = exports.SHORTCUT_SUBMITTED = 'SHORTCUT_SUBMITTED';
const SUCCESSFUL_REQUEST = exports.SUCCESSFUL_REQUEST = 'SUCCESSFUL_REQUEST';